import {langMutations, langState} from "./js/addStores/langStore";

export default {
    state: {
        ...langState,
        isMain: false,
        from: {
            error: false,
            id: 1,
            name: 'Ташкент'
        },
        to: {
            error: false,
            id: null,
            name: ''
        },
        date: {
            error: false,
            date: Vue.moment
        },
        kioskId: null,
        order: {},
        passengers: [],
        payment: {},
        totalAmount: 0,
        addDay: 0,
        selectedTrip: {},
        selectedSeats: [],
        taxes: [],
        allPrice: 0,
    },
    getters: {},
    mutations: {
        ...langMutations,
        setSelectedDateOnChangeTab(state, day){
            state.addDay = day;
        },
        setFrom(state, name) {
            state.from.name = name;
        },
        setId(state, id) {
            state.kioskId = id;
        }
    }
}
